// extracted by mini-css-extract-plugin
module.exports = {"root":"index__O4yGrfRB","reference":"index_reference__O4yGrfRB","rootDesigner":"index_rootDesigner__O4yGrfRB"};